/* Sarthi Mart: put the Alert Me (back-in-stock app) "Notify Me" button where
   the sold-out button was, on product grids, home cards, combo cards and the
   product page. The app keeps doing the work (its own click opens its sign-up
   form for that product); this file only moves and dresses its buttons. */
(function () {
  'use strict';
  if (window.SarthiNotifyMeLoaded) return;
  window.SarthiNotifyMeLoaded = true;

  var BELL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>';
  var INNER = '<span class="sarthi-notify-inner"><span class="sarthi-notify-icon">' + BELL +
    '</span><span class="sarthi-notify-text">Notify Me</span></span>';

  // The app styles its buttons inline (black, square). Keep only its show/hide.
  function keepDisplayOnly(btn) {
    var value = btn.style.getPropertyValue('display');
    var priority = btn.style.getPropertyPriority('display');
    btn.removeAttribute('style');
    if (value) btn.style.setProperty('display', value, priority);
  }
  function watchStyle(btn) {
    if (btn.__sarthiNotifyWatch) return;
    btn.__sarthiNotifyWatch = new MutationObserver(function () {
      var s = btn.getAttribute('style') || '';
      if (s.replace(/display\s*:[^;]*;?/i, '').trim()) keepDisplayOnly(btn);
    });
    btn.__sarthiNotifyWatch.observe(btn, { attributes: true, attributeFilter: ['style'] });
  }
  function dress(btn, classes) {
    classes.forEach(function (c) { if (c) btn.classList.add(c); });
    if (!btn.querySelector('.sarthi-notify-inner')) btn.innerHTML = INNER;
    var title = btn.getAttribute('data-title');
    btn.setAttribute('aria-label', title ? 'Notify me when ' + title + ' is back in stock' : 'Notify me when back in stock');
    keepDisplayOnly(btn);
    watchStyle(btn);
  }
  function isShown(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function pickSold(host) {
    var list = Array.prototype.filter.call(
      host.querySelectorAll('.m-add-to-cart[disabled], .sp-sold'),
      function (el) { return !el.closest('.notify-bis-wrapper') && !el.classList.contains('sarthi-soldout-replaced'); }
    );
    for (var i = 0; i < list.length; i++) if (isShown(list[i])) return list[i];
    return list[0] || null;
  }

  // Grid, home and combo cards: the app adds <div.notify-bis-wrapper> to the card.
  function placeCardButton(wrap) {
    var btn = wrap.querySelector('.collection-notify-me-btn');
    if (!btn || btn.dataset.sarthiPlaced) return;
    var host = wrap.parentElement;
    if (!host) return;

    var combo = host.closest('[data-byos-product-card]');
    if (combo) {
      var own = combo.querySelector('.sarthi-notify-fallback') || combo.querySelector('[data-byos-add-btn]');
      if (own) own.insertAdjacentElement('afterend', btn);
      dress(btn, ['sarthi-byos-card-add-btn', 'sarthi-notify-btn', 'sarthi-notify-btn--combo']);
      combo.classList.add('has-sarthi-notify');
    } else {
      var sold = pickSold(host);
      if (sold && sold.classList.contains('sp-sold')) {
        sold.insertAdjacentElement('afterend', btn);
        sold.classList.add('sarthi-soldout-replaced');
        dress(btn, ['sarthi-notify-btn', 'sarthi-notify-btn--sp']);
      } else if (sold) {
        sold.insertAdjacentElement('afterend', btn);
        sold.classList.add('sarthi-soldout-replaced');
        var keep = String(sold.className).split(/\s+/).filter(function (c) {
          return c && c !== 'm-add-to-cart' && c !== 'm-spinner-button' && c !== 'sarthi-soldout-replaced';
        });
        dress(btn, keep.concat(['sarthi-notify-btn', 'sarthi-notify-btn--card']));
      } else {
        // Card without a sold-out button: leave it where the app put it, just restyle.
        dress(btn, ['m-button', 'sarthi-notify-btn', 'sarthi-notify-btn--card']);
        btn.dataset.sarthiPlaced = '1';
        return;
      }
    }
    btn.dataset.sarthiPlaced = '1';
    if (!wrap.querySelector('button')) wrap.classList.add('sarthi-notify-wrap-empty');
  }

  // Product page: the app's own button sits under the main buy button.
  function placeProductButton() {
    var btn = document.getElementById('notifyMeButton');
    if (!btn) return;
    if (!btn.classList.contains('sarthi-notify-btn--main')) {
      dress(btn, ['sarthi-notify-btn', 'sarthi-notify-btn--main']);
    }
    // Sticky bottom bar: a twin button that opens the same form.
    document.querySelectorAll('.sarthi-sticky-atc-btn').forEach(function (sticky) {
      var next = sticky.nextElementSibling;
      if (next && next.classList.contains('sarthi-notify-btn--sticky')) return;
      var twin = document.createElement('button');
      twin.type = 'button';
      twin.className = 'm-button sarthi-notify-btn sarthi-notify-btn--sticky';
      twin.innerHTML = INNER;
      twin.setAttribute('aria-label', 'Notify me when back in stock');
      var cs = window.getComputedStyle(sticky);
      twin.style.flex = cs.flex;
      twin.style.minWidth = cs.minWidth;
      twin.addEventListener('click', function () {
        var main = document.getElementById('notifyMeButton');
        if (main) main.click();
      });
      sticky.insertAdjacentElement('afterend', twin);
      sticky.classList.add('sarthi-soldout-replaced');
    });
  }

  function scan() {
    document.querySelectorAll('.notify-bis-wrapper').forEach(placeCardButton);
    placeProductButton();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.id === 'notifyMeButton' || (n.classList && n.classList.contains('notify-bis-wrapper')) ||
              (n.querySelector && n.querySelector('.notify-bis-wrapper, #notifyMeButton, .collection-notify-me-btn'))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
